export const API_PREFIX = '/api/v1';
export const HEALTH_ENDPOINT = '/health';
export const DEFAULT_PORT = 3456;
export const DEFAULT_HOST = '0.0.0.0';
export const APP_NAME = 'Peekbox';
export const APP_VERSION = '0.2.0';
